import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import OrderList from "./orderslist";
import Footer from "./Footer";
const CustomerOrder = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <OrderList />
      <Footer />
    </>
  );
};

export default CustomerOrder;
